import React from 'react';
import {Label} from '@fluentui/react';
import {setManChoice} from "../../../actions/CreateSiteActions/dimensionActions";
import {connect} from "react-redux";
import TreeComponent from "../CommonComponents/TreeComponent";
import { isManagementValid } from '../Step3/Validator';
import InfoTooltip from '../../formFields/InfoTooltip';
import NewModal from "./NewModal";
import {ItemPicker} from "../CommonComponents/ItemPicker";
import Warning from '../CommonComponents/Warning';
import Api from '../../../services/Api'

class Management extends React.Component {

    constructor(props)
    {
        super(props)
        this.state = {
            firstLevel : []
        }
    }

    componentDidMount() {
        
        if (!this.props.selectedMan && this.props.managementConfig.defaultKey) {
            this.fitDefaultChoice(this.props.managementConfig.defaultKey);
        }

        if (!this.props.managementConfig.isDisabled) {
            this.fitPossibilities();
        }
    }

    fitDefaultChoice(defaultKey) {
        Api.get(`/Management?key=${defaultKey}`)
            .then(res => res.data)
            .then(posts => {
                const post = posts.find(x => x.key === this.props.managementConfig.defaultKey);
                this.props.setManagement(post);
            });
    }

    fitPossibilities() {
        Api.get(`/Management?${this.props.managementConfig.onlyChildrenAllowed ? `key=${this.props.managementConfig.defaultKey}&parent=all` : 'parent=abb'}`)
            .then(res => res.data)
            .then(posts => {
                this.setState({firstLevel: posts});
            });
    }

    render() {
        const fulladdressSearch = `/Management?${this.props.managementConfig.onlyChildrenAllowed ? `parent=${this.props.managementConfig.defaultKey}&` : ''}search=`;
        const fulladdressTree =  '/Management'
        const geo = this.state.firstLevel.map(item => 
            <TreeComponent
                key = {item.key}
                child = {item}
                itemSelector = {this.props.setManagement}
                selectedItem = {this.props.selectedMan}
                url = {fulladdressTree}
            />)

        const warning = this.props.possibleWarning && !isManagementValid()
                        ? <Warning element="withlabel-basepicker"/> : null;
        const error = warning && <div className='errorMessage'>Please select an option</div>;
        const toModal =  <div className='tree'>
            {geo}
        </div>

        return (
            <div>
                <div className="wizard-inside">
                    <div className="item-title">
                        Select the area related to the team
                        <InfoTooltip content='Select name of the organization being legal owner of the Site.' />
                    </div>
                    {warning}
                    <ItemPicker key = "man"
                        itemSelector={this.props.setManagement}
                        searchTitle="Search for Accelleron areas"
                        url={fulladdressSearch}
                        selection= {this.props.selectedMan}
                        isPickerDisabled = {this.props.managementConfig.isDisabled}
                    />
                    <Label style={{marginTop:'10px'}}>Or select item from tree</Label>
                    <NewModal
                        component = {toModal}
                        selection = {this.props.selectedMan}
                        isPickerDisabled = {this.props.managementConfig.isDisabled}
                    />
                    {error}
                </div>
            </div>
        );
    }
}

const mapActionToProp = {
    setManagement: setManChoice
}

const mapStateToProps  = state => ({
    selectedMan: state.newSite.management,
    possibleWarning : state.wizard.nextStepRequested,
    managementConfig: (state.newSite.Template.config || {}).managementConfig || {}
})

export default connect(mapStateToProps, mapActionToProp)(Management)








// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/Management.js